import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import React from "react";

const Search = ({search,setSearch}) => {
  return (
    <div className="flex-grow">
      <Input
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ borderRadius: "8px",width:'100%',maxWidth:'400px' }}
        size="large"
        placeholder="Search by role, client and department..."
        prefix={<SearchOutlined />}
      />
    </div>
  );
};

export default Search;
